import Physiotherapist from "./Physiotherapist";

export default Physiotherapist